<template>
  <CmsTemplate :pageName="'companies'" :pageTitle="$t('commons.companies')">
    <div class="row" style="margin-bottom: 15px;">
        <div class="col-xs-12 col-sm-4 col-md-3 pull-right">
          <label>{{ $t('content.byFocus') }}</label>
          <select v-model="focus" class="form-control" v-on:change="applyFilters">
            <option value="">{{ $t('content.selectFocus') }}</option>
            <option>Aeronáutico</option>
            <option>Agronegócio</option>
            <option>Alimentos</option>
            <option>Economia criativa</option>
            <option>Eletrônica</option>
            <option>Energia</option>
            <option>Espacial</option>
            <option>Meio ambiente</option>
            <option>Mineral</option>
            <option>Petróleo e gás natural</option>
            <option>Química</option>
            <option>Recursos hídricos</option>
            <option>Saúde animal</option>
            <option>Saúde humana</option>
            <option>Tecnologia da informação</option>
            <option>Telecomunicações</option>
            <option>Transporte aquaviario e construção naval</option>
            <option>Transporte terrestre e hidroviário</option>
          </select>
        </div>
    </div>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">{{ $t("commons.companies") }}</h3>
      </div>
      <div class="box-body">
        <DataTables
          tableId="parks-table"
          :url="this.getApiUrl()"
          :columns="this.columns"
          :columnDefs="this.columnDefs"
          :order="[[1, 'asc']]">
        </DataTables>
      </div>
    </div>
  </CmsTemplate>
</template>
<script>
import CmsTemplate from '@/pages/portal/CmsTemplate'
import DataTables from '@/components/elements/DataTables'

export default {
  name: 'CompaniesPage',
  components: { CmsTemplate, DataTables },
  data () {
    return {
      columns: [
        { label: '', field: 'logoPicture' },
        { label: 'Nome', field: 'name' },
        { label: 'Email', field: 'email' },
        { label: 'Cidade', field: 'city' },
        { label: 'Estado', field: 'state' },
        { label: 'Parque Tecnológico', field: '_links.ea:park.initials' }
      ],
      columnDefs: [
        {
          targets: 0,
          orderable: false,
          render: function (data, type, full, meta) {
            return `
              <img class="img-responsive center-block" style="max-height: 30px;" src=` + data + `>
            `
          }
        }
      ],
      focus: ''
    }
  },
  methods: {
    getApiUrl () {
      return process.env.API_URL + 'companies/'
    },
    applyFilters () {
      $('#parks-table').DataTable().ajax.url(
          this.getApiUrl() + '?focus=' + encodeURIComponent(this.focus)
      ).load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CompaniesPage.vue?6ea72618